<template>
  <div class="d-flex justify-content-center align-items-center vh-100">
    <div class="row">
      <div class="col-md-6 d-flex justify-content-center align-items-center">
        <div class="container">
          <div class="d-none d-md-block d-lg-block d-xl-block">
            <img :src="image" alt="Image" class="mt-2 img-fluid" />
          </div>
          <h4 class="text-center">PAYZEEP AGENCY BANKING</h4>
        </div>
      </div>
      <div class="col-md-6 d-flex justify-content-center align-items-center">
        <div class="left-contents">
          <div class="d-flex justify-content-center align-items-center">
            <!-- <img
                src="../assets/img/"
                class="img-fluid"
              /> -->
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <card class="card mt-5 border w-50" title="Enter OTP">
              <form @submit.prevent>
                <div class="row">
                  <div class="col-md-12 p-2">
                    <p>
                      Please enter the 4-digit OTP sent to your email associated
                      with
                      {{ user.email }}
                    </p>
                  </div>

                  <div class="col-md-12 p-2">
                    <input
                      type="password"
                      class="form-control border"
                      placeholder="Enter OTP"
                      v-model="user.loginOtp"
                      maxlength="4"
                    />
                  </div>
                </div>

                <div class="text-center">
                  <p-button
                    type="primary"
                    round
                    @click.native.prevent="loginUserOtp"
                  >
                    <div
                      class="spinner-grow"
                      role="status"
                      v-if="loading.show === true"
                    ></div>
                    Confirm
                  </p-button>
                </div>
              </form>
            </card>
          </div>
          <!-- Resend OTP section -->
          <div class="text-center mt-1">
            <p>
              Didn't receive the OTP? Click
              <span
                style="cursor: pointer; text-decoration: underline"
                @click="resendOtp"
              >
                here
              </span>
              to resend.
            </p>
          </div>
          <div class="text-center mt-1">
            <p v-if="countdown > 0">
              OTP will expire in {{ formattedCountdown }}
            </p>
            <p v-else>
              OTP has expired. Click
              <span
                style="cursor: pointer; text-decoration: underline"
                @click="resendOtp"
              >
                here
              </span>
              to resend.
            </p>
          </div>
          <div class="styled-box">
            <span class="icon"
              ><img
                src="@/assets/img/paymiSolution.png"
                alt="Powered by Paymi Solutions"
            /></span>
            <span class="styled-text"> Powered by Paymi Solutions </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      user: {
        email: "",
        otp: "",
      },
      image: require("@/assets/img/banner-img-paymi.png"),
      countdown: localStorage.getItem("otpCountdown") || 600,
    };
  },
  computed: {
    ...mapState(["auth", "loading"]),
    formattedCountdown() {
      const minutes = Math.floor(this.countdown / 60);
      const seconds = this.countdown % 60;
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    },
  },
  methods: {
    ...mapActions(["loginOtp"]),
    loginUserOtp() {
      this.loginOtp(this.user);
    },
    resendOtp() {
      this.$router.push("/login");
    },

    beforeDestroy() {
      clearInterval(this.countdownInterval);
    },
    startCountdown() {
      this.countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
          localStorage.setItem("otpCountdown", this.countdown);
        }
      }, 1000);
    },
  },

  mounted() {
    this.user.email = this.$route.params.email;
    this.startCountdown();
  },
};
</script>

<style>
.styled-box {
  margin-top: 4rem;
  margin-left: 22rem;
  margin-right: 22rem;
  display: flex;
  width: 192px;
  height: 40px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 4px;
  background: var(--Grey-White-Grey-100, #f7f7f7);
}
.icon {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: var(--Grey-White-White-full, #fff);
}
.styled-text {
  color: var(--Blue-Blue-primary, #2c3adf);
  font-family: "Work Sans";
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 200% */
  letter-spacing: -0.05px;
}
</style>
